$(document).ready(function() {
  const mainPageClassSelector            = ".chapter-overview.page-container";
  const duplicationClassSelector         = ".chapter-duplication";
  const sourceApplicationIdSelector      = "#source_application_id";
  const sourceCourseIdSelector           = "#source_course_id";
  const sourceChapterIdSelector          = "#source_chapter_id";
  const destinationStoryIdSelector       = "#destination_story_id";
  const duplicationWarningsClassSelector = ".duplication-warnings";
  const spinnerClassSelector             = ".spinner";
  const urlForDuplicationWarnings        = "/duplication/chapter_duplications/warnings.json";

  const retrieveDuplicationWarningsForChapterDuplication = function({ formIdSelector, sourceApplicationId, sourceCourseId, sourceChapterId, destinationStoryId }) {
    const payload = {
      source_application_id: sourceApplicationId,
      source_course_id:      sourceCourseId,
      source_chapter_id:     sourceChapterId,
      destination_story_id:  destinationStoryId,
    }

    retrieveDuplicationWarningsForChapterDuplicationPending(formIdSelector);

    $.ajax({
      url:         urlForDuplicationWarnings,
      method:      "POST",
      dataType:    "json",
      contentType: "application/json",
      data:        JSON.stringify(payload),
    }).done(function(response) {
      retrieveDuplicationWarningsForChapterDuplicationCompleted(formIdSelector);

      const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);

      if (duplicationWarningsElement) {
        if (response.available) {
          const duplicationWarningsHtml = duplicationWarningsForChapterDuplicationHtml(response);

          if (duplicationWarningsElement) {
            duplicationWarningsElement.html(duplicationWarningsHtml);
            duplicationWarningsElement.show();
          }
        } else {
          duplicationWarningsElement.hide();
        }
      }
    }).fail(function(error) {
      retrieveDuplicationWarningsForChapterDuplicationCompleted(formIdSelector);

      console.error(error);
    });
  }

  const retrieveDuplicationWarningsForChapterDuplicationPending = function(formIdSelector) {
    const duplicationWarningsElement = $(`${mainPageClassSelector} ${formIdSelector} ${duplicationWarningsClassSelector}`);
    const spinnerElement             = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement              = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (duplicationWarningsElement) {
      duplicationWarningsElement.hide();
    }

    if (spinnerElement) {
      spinnerElement.show();
    }

    if (submitElement) {
      submitElement.hide();
    }
  }

  const retrieveDuplicationWarningsForChapterDuplicationCompleted = function(formIdSelector) {
    const spinnerElement = $(`${mainPageClassSelector} ${formIdSelector} ${spinnerClassSelector}`);
    const submitElement  = $(`${mainPageClassSelector} ${formIdSelector} input[type="submit"]`);

    if (spinnerElement) {
      spinnerElement.hide();
    }

    if (submitElement) {
      submitElement.show();
    }
  }

  const duplicationWarningsForChapterDuplicationHtml = function(response) {
    const duplicationWarningsHtml = $.map(response.details, function (warningDetail, index) {
      return `
        <dt class="duplication-warning-description">${index + 1}) ${warningDetail.description}</dt>
        <dd class="duplication-warning-message">${warningDetail.message}</dd>
      `;
    }).join("\n");

    return `
      <div class="duplication-warnings-summary">${response.summary}</div>
      <dl>${duplicationWarningsHtml}</dl>
    `;
  }

  $(mainPageClassSelector).on("change", `${duplicationClassSelector} ${destinationStoryIdSelector}`, function(event) {
    const currentElement = $(this);
    const closestForm    = currentElement.closest('form')[0];

    if (closestForm) {
      const formId                     = closestForm.id;
      const formIdSelector             = `#${formId}`;
      const sourceApplicationIdElement = $(`${formIdSelector} ${sourceApplicationIdSelector}`);
      const sourceCourseIdElement      = $(`${formIdSelector} ${sourceCourseIdSelector}`);
      const sourceChapterIdElement     = $(`${formIdSelector} ${sourceChapterIdSelector}`);

      if (sourceApplicationIdElement && sourceCourseIdElement && sourceChapterIdElement) {
        const sourceApplicationId = sourceApplicationIdElement.val();
        const sourceCourseId      = sourceCourseIdElement.val();
        const sourceChapterId     = sourceChapterIdElement.val();
        const destinationStoryId  = currentElement.val();

        retrieveDuplicationWarningsForChapterDuplication({ formIdSelector: formIdSelector, sourceApplicationId: sourceApplicationId, sourceCourseId: sourceCourseId, sourceChapterId: sourceChapterId, destinationStoryId: destinationStoryId });
      }
    }
  });
});